/** Pomocné funkce pro data, bez závislosti na časovém pásmu telefonu. */

/** ISO týden, např. 2026-W42. */
export function isoWeek(date: string) {
  const d = new Date(date + 'T00:00:00Z');
  const day = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - day + 3);
  const y = d.getUTCFullYear();
  const first = new Date(Date.UTC(y, 0, 4));
  const w = 1 + Math.round(((d.getTime() - first.getTime()) / 86400000 - 3 + ((first.getUTCDay() + 6) % 7)) / 7);
  return `${y}-W${String(w).padStart(2, '0')}`;
}

/** Text začínající =, +, @ nebo -(písmeno) by Excel z CSV spustil jako vzorec – předsadíme apostrof. */
export const noFormula = (s: string) => (/^[=+@\t\r]|^-[^\d.,\s]/.test(s) ? `'${s}` : s);
